export var Gate;
(function (Gate) {
    Gate[Gate["Off"] = 0] = "Off";
    Gate[Gate["On"] = 1] = "On";
    Gate[Gate["Loop"] = 2] = "Loop";
})(Gate || (Gate = {}));
